<template>
  <loading-view :show="loading" />
  <div v-if="!loading">
    <header-component />
    <router-view />
    <contact-buttons />
    <footer-component />
    <free-trial-button />
    <social-media-links />
  </div>
</template>

<script>
import ContactButtons from "./components/buttons/ContactButtons.vue";
import HeaderComponent from "./components/HeaderComponent.vue";
import FooterComponent from "./components/FooterComponent.vue";
import LoadingView from "./views/LoadingView.vue"; // تأكد من الاسم
import FreeTrialButton from "./components/buttons/FreeTrialButton.vue";
import SocialMediaLinks from "./components/buttons/SocialMediaLinks.vue";
import { useHead } from "@vueuse/head";

useHead({
  title: "Al-Furqan Academy - Online Quran & Arabic Classes",
  meta: [
    {
      name: "description",
      content: "Learn Quran, Arabic, and Islamic Studies with expert tutors.",
    },
    { property: "og:title", content: "Al-Furqan Academy" },
    {
      property: "og:description",
      content: "Online Quran & Arabic Classes for all levels.",
    },
    {
      property: "og:image",
      content: "https://www.al-furqanacademy.com/images/og-image.jpg",
    },
    { property: "og:type", content: "website" },
    { property: "og:url", content: "https://www.al-furqanacademy.com" },
    { name: "twitter:card", content: "summary_large_image" },
  ],
  link: [{ rel: "canonical", href: "https://www.al-furqanacademy.com" }],
});

export default {
  name: "App",
  data() {
    return {
      loading: true,
    };
  },
  created() {
    this.$store.dispatch("loadCourses");
  },
  mounted() {
    this.loading = false; // Simulate loading completion
    // setTimeout(() => {
    //   this.loading = false;
    // }, 2000);
  },
  components: {
    HeaderComponent,
    ContactButtons,
    FooterComponent,
    LoadingView,
    FreeTrialButton,
    SocialMediaLinks,
  },
};
</script>
<style lang="scss">
@use "./sass/base/typography" as *;
@use "./sass/base/reset" as *;
</style>
